import { useState } from "react";

import {
  ExternalContainer,
  InternalContainer,
} from "../../../../components/Reusable/Layout";
import { GiftcardTable, GiftcardSearchFilter } from "./component";
import { CreateGiftcardModal } from "../../Modal/Giftcard/CreateGiftcardModal";
import type { Giftcard as GiftCardType, GiftcardProps } from "./types";
import { EditGiftCardModal } from "../../Modal/Giftcard/EditGiftcardModal";
import { DeleteGiftCardPlanModal } from "../../Modal/Giftcard/DeleteGiftCardPlan";

export const Giftcard: React.FC<GiftcardProps> = ({
  giftcardPlans,
  loading,
  error,
  statusFilter,
  setStatusFilter,
  onGiftcardPlanClick,
  searchTerm,
  setSearchTerm,
}) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [productType, setProductType] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedGiftCardPlan, setSelectedGiftCardPlan] = useState<
    undefined | GiftCardType
  >(undefined);
  const [giftCardPlanId, setGiftCardPlanId] = useState<number | null>(null);

  const onEditClick = (giftCard: GiftCardType) => {
    setSelectedGiftCardPlan(giftCard);
    setIsEditModalOpen(true);
  };

  const onDeleteClick = (id: number) => {
    setGiftCardPlanId(id);
    setIsDeleteModalOpen(true);
  };
  return (
    <ExternalContainer>
      <div className="h-screen dark:bg-[#FFFFFF1A] w-[1030px]">
        <InternalContainer headerText="Gift Card Plans">
          <div className="flex flex-col">
            <GiftcardSearchFilter
              onStatusFilter={setStatusFilter}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              onCreateNewProduct={(type) => {
                setProductType(type);
                setIsCreateModalOpen(true);
              }}
            />
            <div className="border border-[#FFFFFF1A]">
              <GiftcardTable
                giftcardPlans={giftcardPlans}
                statusFilter={statusFilter}
                onEditClick={onEditClick}
                onDeleteClick={onDeleteClick}
                onGiftcardPlanClick={onGiftcardPlanClick}
                loading={loading}
              />
            </div>
          </div>
        </InternalContainer>
        <CreateGiftcardModal
          isOpen={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
        />

        <EditGiftCardModal
          giftCardPlan={selectedGiftCardPlan}
          isOpen={isEditModalOpen && selectedGiftCardPlan !== undefined}
          onClose={() => {
            setIsEditModalOpen(false);
            setSelectedGiftCardPlan(undefined);
          }}
        />
        <DeleteGiftCardPlanModal
          id={giftCardPlanId}
          isOpen={isDeleteModalOpen && giftCardPlanId !== null}
          onClose={() => {
            setIsDeleteModalOpen(false);
            setGiftCardPlanId(null);
          }}
        />
      </div>
    </ExternalContainer>
  );
};

export default Giftcard;
